import React, { Component } from 'react';
import './styles.css';

export default class Results extends Component {
  render() {
    return (
      <div className="dashboard">
        <h1>Results page</h1>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Results/Results.js